import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    all (request) {
      return api.post(`/bosheet/statistics`, request)
    },

    insert (request) {
      return api.post('/bosheet/insert', request)
    },

    full (request) {
      return api.post('/bosheet/full', request)
    },

    export (request) {
      return api.post('/bosheet/export', request)
    },

    summary (request) {
      return api.post('/bosheet/summary', request)
    }
  }
} else {
  module = {
    _all: [],

    all (request) {
      const die = rand(1, 100)
      if (die < 10) {
        return delay(1500)({
          data: {
            err: 'Erreur au chargement des fiches.'
          }
        })
      }

      this._all = generateRandomData()

      return delay(1500)({
        data: {
          v: this._all.slice()
        }
      })
    }
  }
}

function rand (lower, upper) {
  return Math.floor(lower + Math.random() * (upper - lower))
}

function randArray (array) {
  const index = rand(0, array.length)
  return array[index === array.length ? index - 1 : index]
}

function randDate () {
  const day = rand(0, 90)

  return new Date(2019, 0, day, 12)
}

function generateDay () {
  const protocols = [
    'bactADI',
    'reaBactADI',
    'neoInfADI',
    'reaInfADI',
    'diaInfADI'
  ]

  return {
    protocol: randArray(protocols),
    day: randDate(),
    count: rand(1, 50),
    surveillance: 'random'
  }
}

function generateRandomData () {
  const iterations = rand(10, 15)
  const result = []
  for (let i = 0; i !== iterations; ++i) {
    result.push(generateDay())
  }
  return result
}

export default module
